import { EndpointErrorMessagesType } from './ErrorHandlingMessages';

export const TicketSupportErrorMessages: EndpointErrorMessagesType = {
  400: { default: 'error:ticketSupport400Default' },
  500: { default: '' },
};
